export enum GeolocationStatus {
  instructions = 'instructions',
  accepted = 'accepted',
  'distance-lock' = 'distance-lock',
  'not-accepted' = 'not-accepted',
  'not-support' = 'not-support',
}